import { lighten } from 'polished'
import styled from 'styled-components'

import { ButtonAsync } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	fullWidth?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const Solid = styled(ButtonAsync)<Props>`
	color: ${helpers.color.textContrast};
	background-color: ${({ type = 'primary', theme }) => theme.color[type]};
	-webkit-font-smoothing: antialiased;
	font-weight: ${helpers.font.weight.medium};
	font-family: ${helpers.font.family.header};
	font-size: ${helpers.font.size.base};
	width: ${({ fullWidth }) => fullWidth && '100%'};
	border-radius: 8px;
	min-width: 60px;
	height: 36px;
	padding-left: 18px;
	padding-right: 18px;
	transition: color 0.2s, background-color 0.2s;
	isolation: isolate;

	&:is(:focus-visible, :hover) {
		background-color: ${({ type = 'primary', theme }) => lighten(0.1, theme.color[type])};
	}

	&:focus-visible {
		outline: 2px solid ${helpers.color.link};
		outline-offset: -2px;
	}

	&:after {
		content: '';
		display: block;
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		pointer-events: none;
		background-image: radial-gradient(circle, ${({ type = 'primary', theme }) => lighten(0.4, theme.color[type])} 16%, transparent 16.01%);
		background-repeat: no-repeat;
		background-position: 50%;
		transform: scale(10, 10);
		opacity: 0;
		transition: transform 0.7s, opacity 0.9s;
	}

	&:active:after {
		transform: scale(0, 0);
		opacity: 0.3;
		transition: 0s;
	}

	&:disabled:after {
		opacity: 0;
	}

	&:disabled {
		background-color: ${helpers.color.disabledContrast};
		color: ${helpers.color.disabled};
	}
`
